import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#F3F4F6",
  class: "no-preview-available",
  viewBox: "0 0 200 200"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("text", {
  x: "50%",
  y: "170",
  fill: "#9CA3AF",
  "font-family": "Arial, sans-serif",
  "font-size": "12",
  "text-anchor": "middle"
}, " No Preview Available ", -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }